"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.resetSwap = exports.resetSwapModal = exports.getTransactionStatus = exports.swapFailed = exports.swapFound = exports.performSwap = exports.fromEVMToNonEVMSwap = exports.fromNonEVMToEVMSwap = exports.startSwap = void 0;
const WalletSwapWrapperSlice_1 = require("./WalletSwapWrapperSlice");
const serverRequest = __importStar(require("../../../common-client/axiosApiClient"));
const algorandServerRequest = __importStar(require("./WalletSwapWrapperClient"));
const Web3Helper_1 = __importDefault(require("../../../helper/web3/Web3Helper"));
const algorandHelper_1 = require("../../../helper/AlgoSDK/algorandHelper");
const react_hot_toast_1 = __importDefault(require("react-hot-toast"));
const constants_1 = require("../../../helper/constants");
const bridgePool_json_1 = __importDefault(require("../../../helper/bridgePool.json"));
const ferrum_plumbing_1 = require("ferrum-plumbing");
// import * as myTradesActions from "../../../redux/my-trades/myTradesActions";
const { actions } = WalletSwapWrapperSlice_1.walletSwapperSlice;
const startSwap = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.startSwap());
});
exports.startSwap = startSwap;
const fromNonEVMToEVMSwap = (fromInfo, amount, toInfo, sourceAddress, targetAddress, targetNetwork, authToken) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e;
    dispatch(actions.initiateSwap({
        sourceNetwork: (_a = fromInfo === null || fromInfo === void 0 ? void 0 : fromInfo.token) === null || _a === void 0 ? void 0 : _a.currency.split(":")[0],
        targetNetwork: (_b = toInfo === null || toInfo === void 0 ? void 0 : toInfo.token) === null || _b === void 0 ? void 0 : _b.currency.split(":")[0],
    }));
    yield (0, algorandHelper_1.nonEVMSwap)(sourceAddress, ((_c = fromInfo === null || fromInfo === void 0 ? void 0 : fromInfo.token) === null || _c === void 0 ? void 0 : _c.currency.split(":")[0]) === "ALGORAND"
        ? 81317600
        : Number((_d = fromInfo === null || fromInfo === void 0 ? void 0 : fromInfo.token) === null || _d === void 0 ? void 0 : _d.currency.split(":")[1]), amount, (_e = toInfo === null || toInfo === void 0 ? void 0 : toInfo.token) === null || _e === void 0 ? void 0 : _e.currency.split(":")[1], targetAddress, targetNetwork, (txId) => dispatch(actions.transactionIdReceived({ transactionId: txId })))
        .then((tx) => __awaiter(void 0, void 0, void 0, function* () {
        // console.log("NON EVM swap response: ", tx);
        return algorandServerRequest
            .createSwapTransaction({
            id: tx,
            receiveNetwork: fromInfo.network.networkName,
            receiveCurrency: fromInfo.token.currency,
            receiveAddress: sourceAddress,
            // receiveAddress:
            //   fromInfo?.network?.networkName === "ALGORAND"
            //     ? 81317600
            //     : fromInfo.token.address,
            receiveAmount: amount,
            receiveTransactionId: tx,
            sendAmount: amount,
            sendNetwork: toInfo.network.networkName,
            sendAddress: targetAddress,
            sendCurrency: toInfo.token.currency,
        })
            .then(() => __awaiter(void 0, void 0, void 0, function* () {
            return serverRequest
                .processFromNonEvmSwapTransaction(tx, toInfo.network.networkName, targetAddress, toInfo.token.currency, amount.toString(), authToken)
                .then((processTx) => {
                // console.log(processTx, "tx tx");
                dispatch(actions.transactionCompleted());
                return algorandServerRequest
                    .newWithdrawItem(tx, {
                    id: tx,
                    receiveNetwork: fromInfo.network.networkName,
                    receiveCurrency: fromInfo.token.currency,
                    receiveAddress: sourceAddress,
                    receiveAmount: amount,
                    receiveTransactionId: tx,
                    sendAmount: amount,
                    sendNetwork: toInfo.network.networkName,
                    sendAddress: targetAddress,
                    sendCurrency: toInfo.token.currency,
                    payBySig: processTx.data,
                })
                    .then(() => {
                    dispatch(actions.transactionSwapStatus({ status: "successful" }));
                });
            });
        }));
    }))
        .catch((error) => {
        // console.log(error);
        react_hot_toast_1.default.error((error === null || error === void 0 ? void 0 : error.message) || "Unable to swap.");
        dispatch(actions.transactionFailed());
        dispatch(actions.transactionFailed());
        dispatch(actions.resetSwapModal());
    });
});
exports.fromNonEVMToEVMSwap = fromNonEVMToEVMSwap;
const fromEVMToNonEVMSwap = (fromInfo, amount, toInfo, userAddress, algorandWalletAddress, authToken, networkClient) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _f, _g, _h, _j, _k;
    // console.log({ fromInfo, toInfo });
    dispatch(actions.initiateSwap({
        sourceNetwork: (_f = fromInfo === null || fromInfo === void 0 ? void 0 : fromInfo.token) === null || _f === void 0 ? void 0 : _f.currency.split(":")[0],
        targetNetwork: (_g = toInfo === null || toInfo === void 0 ? void 0 : toInfo.token) === null || _g === void 0 ? void 0 : _g.currency.split(":")[0],
    }));
    const contract = new networkClient.eth.Contract(bridgePool_json_1.default.abi, constants_1.BRIDGE_CONTRACTS[fromInfo.network.networkName]);
    // const targetChain =
    //   toInfo?.network?.networkName === "ALGORAND"
    //     ? 26261
    //     : Networks.for(toInfo?.network?.networkName).chainId;
    // console.log({ targetChain });
    const amountRaw = networkClient.utils.toWei(amount.toString());
    const params = {
        from: userAddress,
        to: constants_1.BRIDGE_CONTRACTS[fromInfo.network.networkName],
        value: 0,
        data: contract.methods
            .swap(fromInfo.token.address, amountRaw, ((_h = toInfo === null || toInfo === void 0 ? void 0 : toInfo.network) === null || _h === void 0 ? void 0 : _h.networkName) === "ALGORAND"
            ? 26261
            : ferrum_plumbing_1.Networks.for((_j = toInfo === null || toInfo === void 0 ? void 0 : toInfo.network) === null || _j === void 0 ? void 0 : _j.networkName).chainId, ((_k = toInfo === null || toInfo === void 0 ? void 0 : toInfo.network) === null || _k === void 0 ? void 0 : _k.networkName) === "ALGORAND"
            ? networkClient.eth.accounts.privateKeyToAccount(networkClient.utils.stringToHex("81317600"), true).address
            : toInfo.token.address)
            .encodeABI(),
    };
    yield networkClient.eth
        .sendTransaction(params)
        .on("transactionHash", (hash) => {
        console.log({ hash }, "transactionHash");
        dispatch(actions.transactionIdReceived({ transactionId: hash }));
    })
        .on("error", (err) => {
        console.log(err === null || err === void 0 ? void 0 : err.message);
    })
        .on("receipt", (receipt) => {
        console.log({ receipt });
        return algorandServerRequest
            .createSwapTransaction({
            id: receipt.transactionHash,
            receiveNetwork: fromInfo.network.networkName,
            receiveCurrency: fromInfo.token.currency,
            receiveAddress: userAddress,
            receiveAmount: amount,
            receiveTransactionId: receipt.transactionHash,
            sendNetwork: toInfo.network.networkName,
            sendAddress: algorandWalletAddress,
            sendCurrency: toInfo.token.currency,
        })
            .then(() => {
            var _a;
            if (((_a = toInfo === null || toInfo === void 0 ? void 0 : toInfo.network) === null || _a === void 0 ? void 0 : _a.networkName) === "ALGORAND") {
                return serverRequest
                    .processFromEvmSwapTransaction(receipt.transactionHash, userAddress, fromInfo.network.networkName, toInfo.network.networkName, algorandWalletAddress, toInfo.network.networkName === "ALGORAND"
                    ? "ALGORAND:81317600"
                    : toInfo.token.currency, 26261, amount, authToken)
                    .then((response) => {
                    return algorandServerRequest.newWithdrawItem(receipt.transactionHash, {
                        algorandWalletAddress,
                        id: receipt.transactionHash,
                        receiveNetwork: fromInfo.network.networkName,
                        receiveCurrency: fromInfo.token.currency,
                        receiveAddress: userAddress,
                        receiveAmount: amount,
                        receiveTransactionId: receipt.transactionHash,
                        sendAmount: amount,
                        sendNetwork: toInfo.network.networkName,
                        sendAddress: algorandWalletAddress,
                        sendCurrency: toInfo.token.currency,
                        payBySig: response.data,
                    });
                });
                // } else {
                //   return serverRequest
                //     .processTransaction(
                //       fromInfo.network.networkName,
                //       receipt.transactionHash,
                //       authToken
                //     )
                //     .then((processTx) => {
                //       // console.log(processTx, "tx tx");
                //       return algorandServerRequest.newWithdrawItem(
                //         receipt.transactionHash,
                //         processTx.data
                //       );
                //     });
            }
        });
    })
        .catch((error) => {
        // console.log(error);
        react_hot_toast_1.default.error((error === null || error === void 0 ? void 0 : error.message) || "Unable to swap.");
        dispatch(actions.transactionFailed());
        dispatch(actions.transactionFailed());
        dispatch(actions.resetSwapModal());
    });
});
exports.fromEVMToNonEVMSwap = fromEVMToNonEVMSwap;
const performSwap = (currency, amount, targetCurrency, authToken, networkClient) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    // console.log("start swap");
    yield serverRequest
        .swapGetTransaction(currency, amount, targetCurrency, authToken)
        .then((response) => __awaiter(void 0, void 0, void 0, function* () {
        const { requests } = response.data;
        const web3Instance = yield new Web3Helper_1.default(networkClient);
        dispatch(actions.initiateSwap({
            sourceNetwork: currency.split(":")[0],
            targetNetwork: targetCurrency.split(":")[0],
        }));
        web3Instance
            .sendTransactionAsync((txId) => dispatch(actions.transactionIdReceived({ transactionId: txId })), requests)
            .then((response) => __awaiter(void 0, void 0, void 0, function* () {
            // console.log(JSON.stringify(response.split("|")[0]));
            // console.log("befor API call transaction Id calling");
            // console.log("container component swap");
            // dispatch(
            //   myTradesActions.loadUserTransactions(
            //     currency.split(":")[0],
            //     authToken
            //   )
            // );
            // console.log(" after API call transaction Id calling");
            yield serverRequest.logSwapTransaction(response.split("|")[0], currency.split(":")[0]);
        }))
            .catch((error) => {
            // console.log(error);
            react_hot_toast_1.default.error((error === null || error === void 0 ? void 0 : error.message) || "Unable to swap.");
            dispatch(actions.transactionFailed());
        });
    }))
        .catch((err) => {
        dispatch(actions.transactionFailed());
        dispatch(actions.resetSwapModal());
        // console.log(err);
    });
});
exports.performSwap = performSwap;
const swapFound = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.transactionCompleted());
});
exports.swapFound = swapFound;
const swapFailed = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.transactionFailed());
});
exports.swapFailed = swapFailed;
const getTransactionStatus = (transactionId, network, authToken) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    yield serverRequest
        .checkTxStatus(transactionId, network, authToken)
        .then((response) => {
        dispatch(actions.transactionSwapStatus({ status: response.data }));
    });
});
exports.getTransactionStatus = getTransactionStatus;
const resetSwapModal = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    dispatch(actions.resetSwapModal());
});
exports.resetSwapModal = resetSwapModal;
const resetSwap = () => (dispatch) => {
    dispatch(actions.swapReset());
};
exports.resetSwap = resetSwap;
//# sourceMappingURL=WalletSwapWrapperActions.js.map